import * as z from 'zod'

import {
  BaseSchema_DogLiabilityV1GetsafeDe,
  Schema_DogLiabilityV1GetsafeDe,
} from '@flows/insurance/schemas'

const schema = z.preprocess(
  (values) => {
    const valuesCopy = { ...(values as Record<string, any>) }

    if (!valuesCopy.previous_insurance_in_last_5y) {
      valuesCopy.cancelled_by_previous_insurer = undefined
      valuesCopy.number_of_claims_in_last_5y = undefined
    }

    return {
      ...valuesCopy,
    }
  },
  Schema_DogLiabilityV1GetsafeDe.innerType()
    .innerType()
    .omit({
      dogs: true,
    })
    .merge(
      z.object({
        dogs: BaseSchema_DogLiabilityV1GetsafeDe.shape.dogs.element
          .omit({
            breed_class: true,
          })
          .merge(
            z.object({
              // ask BE if it can be optional
              breed_class:
                BaseSchema_DogLiabilityV1GetsafeDe.shape.dogs.element.shape.breed_class.optional(),
            })
          )
          .array()
          .nonempty(),
      })
    )
)

export default schema
